import { API } from '@Providers';

interface UpdateCartTotalsPayload {
  split_payment_details: {
    credit_card_amount: number;
  };
}

export default async function (payload: UpdateCartTotalsPayload) {
  const endpoint = '/api/shelter/cart/update-cart-totals-for-split-payment';

  return API({ endpoint, method: 'post', payload });
}
